/** The search field animates between the 40px chip and the 240px field. */
const SEARCH_COLLAPSED_WIDTH = 40
const SEARCH_EXPANDED_WIDTH = 240

/** The box needs its own height: the absolute content no longer pushes it. */
const SEARCH_CONTROL_HEIGHT = 40

const SEARCH_TRANSITION_DURATION = 0.25

export {
  SEARCH_COLLAPSED_WIDTH,
  SEARCH_EXPANDED_WIDTH,
  SEARCH_CONTROL_HEIGHT,
  SEARCH_TRANSITION_DURATION
}
